var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"widget"},[_c('p',{attrs:{"id":"clock"}},[_vm._v(_vm._s(_vm.dateAndTime))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../assets/asm_black_EN.png"),"alt":"Solaris logo"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('p',{attrs:{"id":"title"}},[_vm._v("SOLARIS Machine Status Portal")])])
}]

export { render, staticRenderFns }